export default "__VITE_ASSET__DkkCWwpo__"